import React from "react"
import styled from "styled-components"
import ContactInfo from "./ContactInfo"
import Enactment from "./Enactment"

const StyledFooterBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-inline-start: 1rem;
  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`
export default function FooterBlock() {
  return (
    <StyledFooterBlock>
      <ContactInfo />
      <Enactment />
    </StyledFooterBlock>
  )
}
